export default {
  id: 'requirementsCenter',
  label: 'Requirements Center',
  stores: {
    requirementsCenterStore: {
      import: () => import('@/stores/requirementsCenterStore'),
      storeId: 'requirementsCenter',
      init: () => {},
      cleanup: store => store.unsubscribeAll(),
    },
  },
  globalComponents: {},
  routes: ['RequirementsCenter'],
  nav: [{ label: 'Requirements Center', routeName: 'RequirementsCenter', group: 'more' }],
}
